import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";

import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";
import Anotacoes from "../pages/Anotacoes";
import Tarefas from "../pages/Tarefas";
import Biblioteca from "../pages/Biblioteca";
import Series from "../pages/Series";
import Filmes from "../pages/Filmes";
import Links from "../pages/Links";
import Config from "../pages/Config";
import Agenda from "../pages/Agenda";

// --- COMPONENTE DE PROTEÇÃO (O CADEADO) ---
const PrivateRoute = () => {
    const isAuth = localStorage.getItem("isAuth");
    const expiresAt = localStorage.getItem("isAuthExpiresAt");

    // Sem login → volta para a Home
    if (isAuth !== "true") {
        return <Navigate to="/" replace />;
    }

    // Sessão expirada → limpa e volta para a Home
    if (expiresAt && Date.now() >= Number(expiresAt)) {
        localStorage.removeItem("isAuth");
        localStorage.removeItem("isAuthExpiresAt");
        return <Navigate to="/" replace />;
    }

    // Tudo certo → renderiza layout + página interna
    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
};

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Rota Pública (Login) */}
                <Route path="/" element={<Home />} />

                {/* Rotas Privadas (Protegidas pelo Cadeado) */}
                <Route element={<PrivateRoute />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/anotacoes" element={<Anotacoes />} />
                    <Route path="/tarefas" element={<Tarefas />} />
                    <Route path="/biblioteca" element={<Biblioteca />} />
                    <Route path="/series" element={<Series />} />
                    <Route path="/filmes" element={<Filmes />} />
                    <Route path="/links" element={<Links />} />
                    <Route path="/config" element={<Config />} />
                    <Route path="/agenda" element={<Agenda />} />

                    {/* Qualquer URL desconhecida dentro do app logado → Dashboard */}
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Route>

                {/* Qualquer URL desconhecida fora do app → Home */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}